import React, { useState } from 'react';
import styles from './Houses.module.css';

// Pick ONE student: a search box narrowing a dropdown. `describe` adds a
// suffix to each option (e.g. the student's house).
function StudentField({ id, students, value, onChange, describe }) {
  const [search, setSearch] = useState('');
  const term = search.trim().toLowerCase();
  const matches = students
    .filter((s) => !term || String(s.id) === String(value) || s.full_name?.toLowerCase().includes(term) || s.class_name?.toLowerCase().includes(term))
    .sort((a, b) => (a.full_name || '').localeCompare(b.full_name || ''));

  return (
    <div className="form-group">
      <label htmlFor={id}>Student</label>
      <input
        type="search"
        className={styles.studentSearch}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Type a name or class to narrow the list"
        aria-label="Search students"
      />
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} required>
        <option value="">Select a student ({matches.length})</option>
        {matches.map((student) => (
          <option key={student.id} value={student.id}>
            {student.full_name}
            {student.class_name ? ` — ${[student.class_name, student.stream].filter(Boolean).join(' ')}` : ''}
            {describe ? describe(student) : ''}
          </option>
        ))}
      </select>
    </div>
  );
}

export default StudentField;
